import { render } from "./GroupSelector.vue?vue&type=template&id=207e1950&scoped=true"
import script from "./GroupSelector.vue?vue&type=script&lang=js"
export * from "./GroupSelector.vue?vue&type=script&lang=js"

import "./GroupSelector.vue?vue&type=style&index=0&id=207e1950&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207e1950"]])

export default __exports__